<div
  id="course"
  class="box shadows gradient d-flex justify-content-between"
  [ngClass]="!!colour ? colour : getColour(course.skill)"
  >
  <div class="description ">
    <div class="heading" *ngIf='!!course.title'>{{ course.title }}</div>
    <div class="text">{{ course.description.split('\n')[0] }}</div>
  </div>
  <div class="extra flex-shrink-0">
    <button type="button" mdbBtn class="button more" mdbWavesEffect (click)="loadLink(course.id)" i18n="">More info</button>
  </div>
</div>
